import React, { useState } from "react";
import { useContext } from "react";
import { useHistory, useLocation, matchPath } from "react-router-dom";
import PropTypes, { exact } from "prop-types";
import { UserContext } from "./../UserContext";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { JiraDrawerItemWithDialog } from "./../Jira";
import {
  HomeIcon,
  TutorialsAndVideosIcon,
  PortfolioIcon,
  BenchmarkingIcon,
  DataEnrichmentIcon,
  ForesightIcon,
  AnalyticsIcon,
  MetricsIcon,
  TrendsIcon,
  InsightsIcon,
  DashboardIcon,
  CustomersIcon,
  TeamsIcon,
  CarriersIcon,
  SettingsIcon,
  DefaultViewIcon,
  ListIcon,
  RenewIcon,
  RoundoutIcon,
  RetainIcon,
  MyViewsIcon,
  HanoverIcon,
} from "../Header/Icons";
import { LockMenu } from "./LockMenu";
import {
  isEnrichmentDashboardAllowedForPlan,
  isTeamAnalyticsAllowedForPlan,
  isBenchmarkAllowedForPlan,
  isForecastAllowedForPlan,
  isCarrierAnalyticsAllowedForPlans,
  isInsightsAllowedForPlan,
  isTrendsAllowedForPlan,
  isMetricsAllowedForPlan,
  hideDisabled,
} from "./../../utils/donnaPlansUtil";
import useGetRolesConfig from "../UserContextProvider/useGetRolesConfig";
import LaunchIcon from "@material-ui/icons/Launch";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import BarChartIcon from "@material-ui/icons/BarChart";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import { Tooltip } from "@material-ui/core";
import getRemittanceRedirectLink from "../../utils/getRemittanceRedirectLink";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 190,
    backgroundColor: theme.palette.background.paper,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  icon: {
    minWidth: 30,
    color: "#2D6089",
  },
  expandedMenuItem: {
    background: "#DEE4E8",
    borderRadius: "0 0 5px 5px",
  },
  selected: {
    "&.Mui-selected": {
      background: "#DEE4E8",
      borderRadius: 5,
    },
  },
  selectedCollapse: {
    "&.Mui-selected": {
      background: "#DEE4E8",
      borderRadius: "5px 5px 0 0",
    },
  },
  selectedText: {
    "& > .MuiTypography-root": {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  lockDiv: {
    backgroundColor: "rgb(45,96,137,0.2)",
    width: 15,
    height: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    position: "absolute",
    right: 0,
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const NO_TENANT_DOMO_DASHBOARD_PATH = "/agencyIQ";
const SIAA_DOMO_DASHBOARD_PATH = "/home/agencyIQ";
const SPC_DASHBOARD_PATH = "/home/dashboard/spc";

const OVERALL_DIEM_PATH = "/home/diem/overall";
const OVERALL_VIEW_PATH = "/home/view/overall";
const WELCOME_DONNA = "/home/welcome";
const SCOPED_DIEM_PATH = "/home/diem/team";
const PERSONAL_DIEM_PATH = "/home/diem/personal";
const SCOPED_VIEW_PATH = "/home/view/team";
const PERSONAL_VIEW_PATH = "/home/view/personal";
const OVERALL_DASHBOARD_PATH = "/home/book-of-business";
const SCOPED_DASHBOARD_PATH = "/home/team-book-of-business";
const PORTFOLIO_PATH = "/home/portfolio";
const ANALYTICS_PATH = "/home/analytics";
const SCOPED_ANALYTICS_PATH = "/home/team-analytics";
const PERSONAL_ANALYTICS_PATH = "/home/my-analytics";
const ANALYTICS_CUSTOMER = "/customer/all";
const ANALYTICS_TEAM = "/team";
const ANALYTICS_CARRIER = "/carrier";
const ANALYTICS_METRICS = "/metrics";
const ANALYTICS_TRENDS = "/trends";
const ANALYTICS_INSIGHTS = "/insights";
const ANALYTICS_CUSTOMER_PATH = `${ANALYTICS_PATH}${ANALYTICS_CUSTOMER}`;
const ANALYTICS_TEAM_PATH = `${ANALYTICS_PATH}${ANALYTICS_TEAM}`;
const ANALYTICS_CARRIERS_PATH = `${ANALYTICS_PATH}${ANALYTICS_CARRIER}`;
const ANALYTICS_METRICS_PATH = `${ANALYTICS_PATH}${ANALYTICS_METRICS}`;
const ANALYTICS_TRENDS_PATH = `${ANALYTICS_PATH}${ANALYTICS_TRENDS}`;
const ANALYTICS_INSIGHTS_PATH = `${ANALYTICS_PATH}${ANALYTICS_INSIGHTS}`;
const SCOPED_ANALYTICS_CUSTOMER_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_CUSTOMER}`;
const SCOPED_ANALYTICS_TEAM_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_TEAM}`;
const SCOPED_ANALYTICS_CARRIERS_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_CARRIER}`;
const SCOPED_ANALYTICS_METRICS_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_METRICS}`;
const SCOPED_ANALYTICS_TRENDS_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_TRENDS}`;
const SCOPED_ANALYTICS_INSIGHTS_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_INSIGHTS}`;
const PERSONAL_ANALYTICS_CUSTOMER_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_CUSTOMER}`;
const PERSONAL_ANALYTICS_TEAM_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_TEAM}`;
const PERSONAL_ANALYTICS_CARRIERS_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_CARRIER}`;
const PERSONAL_ANALYTICS_METRICS_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_METRICS}`;
const PERSONAL_ANALYTICS_TRENDS_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_TRENDS}`;
const PERSONAL_ANALYTICS_INSIGHTS_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_INSIGHTS}`;
const FORESIGHT_PATH = "/home/foresight";
const ENRICHMENT_PATH = "/home/enrichment";
const BENCHMARK_PATH = "/home/benchmark";
const HELP_VIDEOS_PATH = "/home/settings/help";
const SETTING_PATH = "/home/settings/app-settings";
const FEATURE_NOT_ALLOWED = "/home/agencyIQ/feature-not-available";
const FEATURE_NOT_ALLOWED_FOR_NO_TENANT = "/agencyIQ/feature-not-available";

const DOMO_TITLE = "Financials";
const REMITTANCE_TITLE = "Remittance";
const SPC_DASHBOARD_TITLE = "SPC";


export function SIAANestedList(props) {
  const { onClose: handleClose, doesNotHaveTenant } = props;
  const classes = useStyles();
  const history = useHistory();
  const { pathname: pathName } = useLocation();
  const { user } = useContext(UserContext);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [automationOpen, setAutomationOpen] = useState(false);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [viewsOpen, setViewsOpen] = useState(false);
  const isAMSSupportPending = user.isAMSSupportPending();
  const tooltipTextForNonDSA =
    isAMSSupportPending ? "This feature is unavailable for your AMS!" : "Please complete the enrollment setup steps to access this feature";
  const tooltipTextForDSA = "This feature is part of AgencyIQ Advanced Plan";

  const { data: rolesConfig } = useGetRolesConfig();
  let hanoverAIEnabled = false;
  if (rolesConfig) {
    const { hanoverAI } = rolesConfig;
    hanoverAIEnabled = hanoverAI;
  }

  const hasSPCFlag = user.hasSPC();
  const userRole = user.getTopRole();
  const userSSORole = user.getSSORole();
  const isSuperUser = userRole === "super-user" ? true : false;
  const isCEOUser =
    userRole === "ceo" || userRole === "super-user" ? true : false;
  const isPowerUser = user.isPowerUser();
  const planType = user.getTenantApi()?.getPlanType();

  const SIAA_REMITTANCE_REDIRECTTO_PATH =
    getRemittanceRedirectLink(userSSORole);

  const isdataEnrichmentAllowed = isEnrichmentDashboardAllowedForPlan(planType);
  const isTeamAnalyticsAllowed = isTeamAnalyticsAllowedForPlan(planType);
  const isBenchMarkAllowedForPlan = isBenchmarkAllowedForPlan(planType);
  const isForesightAllowed = isForecastAllowedForPlan(planType);
  const isVizAccessAllowed = user.isVizAccessAllowed();
  const isInsightsAllowed = isInsightsAllowedForPlan(planType);
  const isCarrierAnalyticsAllowed = isCarrierAnalyticsAllowedForPlans(planType);
  const isTrendsAllowed = isTrendsAllowedForPlan(planType);
  const isMetricsAllowed = isMetricsAllowedForPlan(planType);
  const disabledHidden = hideDisabled(planType);
  const isWidgetAllowedForNoTenant = false;

  const hasOverallDiem = user.isOverallDiemEnabled();
  const hasScopedDiem = user.isScopedDiemEnabled();
  const hasPersonalDiem = user.isPersonalDiemEnabled();
  const hasOverallDashboard = user.isOverallDashboardEnabled();
  const scopedDashboardTitle = hasOverallDashboard
    ? "Team Dashboard"
    : "Dashboard";
  const hasPortfolio = user.isPortfolioEnabled();
  const hasAnalytics = user.isAnalyticsEnabled();
  const hasScopedAnalytics = user.isScopedAnalyticsEnabled();
  const hasPersonalAnalytics = user.isPersonalAnalyticsEnabled();
  const hasCustomerAnalytics = user.isCustomerAnalyticsEnabled();
  const hasTeamAnalytics =
    user.isTeamAnalyticsEnabled() &&
    (!disabledHidden || isTeamAnalyticsAllowed);
  const hasCarrierAnalytics =
    user.isCarrierAnalyticsEnabled() &&
    (!disabledHidden || isCarrierAnalyticsAllowed);
  const hasMetricsAnalytics =
    user.isMetricsAnalyticsEnabled() && (!disabledHidden || isMetricsAllowed);
  const hasTrendsAnalytics =
    user.isTrendsAnalyticsEnabled() && (!disabledHidden || isTrendsAllowed);
  const hasInsightsAnalytics =
    user.isInsightsAnalyticsEnabled() && (!disabledHidden || isInsightsAllowed);
  const hasScopedOverallDashboard = user.isScopedOverallDashboardEnabled();
  const hasSettings = user.isSettingChangeAllowed() && !user.isDemoUser();
  const enableAnalytics =
    hasAnalytics || hasScopedAnalytics || hasPersonalAnalytics;
  let customerAnalyticsLink;
  let teamAnalyticsLink;
  let carrierAnalyticsLink;
  let metricsAnalyticsLink;
  let trendsAnalyticsLink;
  let insightsAnalyticsLink;
  if (hasPersonalAnalytics) {
    customerAnalyticsLink = PERSONAL_ANALYTICS_CUSTOMER_PATH;
    teamAnalyticsLink = PERSONAL_ANALYTICS_TEAM_PATH;
    carrierAnalyticsLink = PERSONAL_ANALYTICS_CARRIERS_PATH;
    metricsAnalyticsLink = PERSONAL_ANALYTICS_METRICS_PATH;
    trendsAnalyticsLink = PERSONAL_ANALYTICS_TRENDS_PATH;
    insightsAnalyticsLink = PERSONAL_ANALYTICS_INSIGHTS_PATH;
  } else if (hasScopedAnalytics) {
    customerAnalyticsLink = SCOPED_ANALYTICS_CUSTOMER_PATH;
    teamAnalyticsLink = SCOPED_ANALYTICS_TEAM_PATH;
    carrierAnalyticsLink = SCOPED_ANALYTICS_CARRIERS_PATH;
    metricsAnalyticsLink = SCOPED_ANALYTICS_METRICS_PATH;
    trendsAnalyticsLink = SCOPED_ANALYTICS_TRENDS_PATH;
    insightsAnalyticsLink = SCOPED_ANALYTICS_INSIGHTS_PATH;
  } else if (hasAnalytics) {
    customerAnalyticsLink = ANALYTICS_CUSTOMER_PATH;
    teamAnalyticsLink = ANALYTICS_TEAM_PATH;
    carrierAnalyticsLink = ANALYTICS_CARRIERS_PATH;
    metricsAnalyticsLink = ANALYTICS_METRICS_PATH;
    trendsAnalyticsLink = ANALYTICS_TRENDS_PATH;
    insightsAnalyticsLink = ANALYTICS_INSIGHTS_PATH;
  }
  let viewPath;
  if (hasOverallDiem) {
    viewPath = OVERALL_VIEW_PATH;
  } else if (hasScopedDiem) {
    viewPath = SCOPED_VIEW_PATH;
  } else {
    viewPath = PERSONAL_VIEW_PATH;
  }
  const isForecastAllowed =
    user.isForecastAllowed() && (!disabledHidden || isForesightAllowed);
  const isEnrichmentDashboardAllowed =
    user.isEnrichmentDashboardAllowed() &&
    (!disabledHidden || isdataEnrichmentAllowed);
  const isBenchmarkAllowed =
    user.isBenchmarkAllowed() && (!disabledHidden || isBenchMarkAllowedForPlan);
  const isAnalyticsPageSelected =
    matchPath(pathName, customerAnalyticsLink) ||
    matchPath(pathName, teamAnalyticsLink) ||
    matchPath(pathName, carrierAnalyticsLink) ||
    matchPath(pathName, PORTFOLIO_PATH) ||
    matchPath(pathName, trendsAnalyticsLink) ||
    matchPath(pathName, insightsAnalyticsLink);
  const isAnalyticsSelected = analyticsOpen || isAnalyticsPageSelected;
  const isAnalyticsTextHighlighted = !analyticsOpen && isAnalyticsPageSelected;
  const isViewsSelected = viewsOpen;

  const isDashboardPageSelected =
    matchPath(pathName, metricsAnalyticsLink) ||
    matchPath(pathName, OVERALL_DASHBOARD_PATH) ||
    matchPath(pathName, SPC_DASHBOARD_PATH) ||
    matchPath(pathName, SIAA_DOMO_DASHBOARD_PATH);
  const isDashboardSelected = dashboardOpen || isDashboardPageSelected;
  const isDashboardTextHighlighted = !dashboardOpen && isDashboardPageSelected;

  const handleDashboardClick = () => {
    setDashboardOpen(!dashboardOpen);
  };

  const handleAutomationClick = () => {
    setAutomationOpen(!automationOpen);
  };

  const handleAnalyticsClick = () => {
    setAnalyticsOpen(!analyticsOpen);
  };

  const handleViewsClick = () => {
    setViewsOpen(!viewsOpen);
  };

  const handleLink = (link, isAccessAllowed, destination) => {
    if (!isAccessAllowed && isAccessAllowed !== undefined) {
      history.push(`${FEATURE_NOT_ALLOWED}/${destination}`);
    } else {
      history.push(link);
    }
    handleClose();
  };
  const handleLinkForNoTenant = (link, isAccessAllowed, destination) => {
    const featureNotAllowedURL = destination
      ? `${FEATURE_NOT_ALLOWED_FOR_NO_TENANT}/${destination}`
      : `${FEATURE_NOT_ALLOWED_FOR_NO_TENANT}`;
    if (!isAccessAllowed && isAccessAllowed !== undefined) {
      history.push(featureNotAllowedURL);
    } else {
      history.push(link);
    }
    handleClose();
  };

  const handleRedirect = (link) => {
    window.open(link, "_blank");
  };

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader
          component="div"
          id="nested-list-subheader"
        ></ListSubheader>
      }
      className={classes.root}
    >
      {doesNotHaveTenant && (
        <>
          <div>
            <ListItem
              button
              onClick={handleDashboardClick}
              selected={isViewsSelected}
              classes={{ root: classes.selectedCollapse }}
            >
              <ListItemIcon classes={{ root: classes.icon }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary="Dashboards"
                className={clsx({
                  [classes.selectedText]: isDashboardTextHighlighted,
                })}
              />
              {!dashboardOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={!dashboardOpen}
              timeout="auto"
              unmountOnExit
              className={classes.expandedMenuItem}
            >
              <List component="div" disablePadding>
                {isCEOUser && (
                  <>
                    {hasOverallDashboard && (
                      <LightTooltip
                        title={
                          !isWidgetAllowedForNoTenant
                            ? tooltipTextForNonDSA
                            : ""
                        }
                      >
                        <ListItem
                          button
                          onClick={() =>
                            handleLinkForNoTenant(
                              OVERALL_DASHBOARD_PATH,
                              isWidgetAllowedForNoTenant
                            )
                          }
                          selected={matchPath(pathName, OVERALL_DASHBOARD_PATH)}
                          classes={{ root: classes.selected }}
                          className={classes.nested}
                        >
                          <ListItemIcon classes={{ root: classes.icon }}>
                            <AnalyticsIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="Analytics"
                            className={clsx({
                              [classes.selectedText]: matchPath(
                                pathName,
                                OVERALL_DASHBOARD_PATH
                              ),
                            })}
                          />
                          {!isWidgetAllowedForNoTenant && (
                            <LockMenu hideTooltip={true} />
                          )}
                        </ListItem>
                      </LightTooltip>
                    )}
                    {!isPowerUser && (
                    <ListItem
                      button
                      onClick={() => handleLink(NO_TENANT_DOMO_DASHBOARD_PATH)}
                      selected={matchPath(
                        pathName,
                        NO_TENANT_DOMO_DASHBOARD_PATH
                      )}
                      className={classes.nested}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <BarChartIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={DOMO_TITLE}
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            NO_TENANT_DOMO_DASHBOARD_PATH
                          ),
                        })}
                      />
                    </ListItem>
                    )}
                  </>
                )}
              </List>
            </Collapse>
          </div>

          {(isCEOUser && !isPowerUser) && (
            <div>
              <ListItem
                button
                onClick={handleAutomationClick}
                selected={false}
                classes={{ root: classes.selectedCollapse }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <SwapVertIcon />
                </ListItemIcon>
                <ListItemText primary="Automation" className={clsx({})} />
                {automationOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={automationOpen}
                timeout="auto"
                unmountOnExit
                className={classes.expandedMenuItem}
              >
                <List component="div" disablePadding>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      onClick={() =>
                        handleLinkForNoTenant(
                          SIAA_REMITTANCE_REDIRECTTO_PATH,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      // selected={matchPath(pathName, SIAA_DOMO_DASHBOARD_PATH)}
                      className={classes.nested}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <AttachMoneyIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={REMITTANCE_TITLE}
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            SIAA_REMITTANCE_REDIRECTTO_PATH
                          ),
                        })}
                      />
                      <LaunchIcon />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                </List>
              </Collapse>
            </div>
          )}

          {isCEOUser && (
            <div>
              <ListItem
                button
                onClick={handleViewsClick}
                selected={isViewsSelected}
                classes={{ root: classes.selectedCollapse }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <MyViewsIcon />
                </ListItemIcon>
                <ListItemText primary="My Views" className={clsx({})} />
                {viewsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={viewsOpen}
                timeout="auto"
                unmountOnExit
                className={classes.expandedMenuItem}
              >
                <List component="div" disablePadding>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() =>
                        handleLinkForNoTenant(
                          `${viewPath}/default`,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      selected={matchPath(pathName, `${viewPath}/default`)}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <DefaultViewIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="Default View"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            `${viewPath}/default`
                          ),
                        })}
                      />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() =>
                        handleLinkForNoTenant(
                          `${viewPath}/viewAll/myList`,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      selected={matchPath(
                        pathName,
                        `${viewPath}/viewAll/myList`
                      )}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <ListIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="My List"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            `${viewPath}/viewAll/myList`
                          ),
                        })}
                      />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() =>
                        handleLinkForNoTenant(
                          `${viewPath}/viewAll/RoundOut`,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      selected={matchPath(
                        pathName,
                        `${viewPath}/viewAll/RoundOut`
                      )}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <RoundoutIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="Round Out"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            `${viewPath}/viewAll/RoundOut`
                          ),
                        })}
                      />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() =>
                        handleLinkForNoTenant(
                          `${viewPath}/viewAll/Retain`,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      selected={matchPath(
                        pathName,
                        `${viewPath}/viewAll/Retain`
                      )}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <RetainIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="Retain"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            `${viewPath}/viewAll/Retain`
                          ),
                        })}
                      />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                  <LightTooltip
                    title={
                      !isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""
                    }
                  >
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() =>
                        handleLinkForNoTenant(
                          `${viewPath}/viewAll/Renew`,
                          isWidgetAllowedForNoTenant
                        )
                      }
                      selected={matchPath(
                        pathName,
                        `${viewPath}/viewAll/Renew`
                      )}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <RenewIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="Renew"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            `${viewPath}/viewAll/Renew`
                          ),
                        })}
                      />
                      {!isWidgetAllowedForNoTenant && (
                        <LockMenu hideTooltip={true} />
                      )}
                    </ListItem>
                  </LightTooltip>
                </List>
              </Collapse>
            </div>
          )}

          {isCEOUser && enableAnalytics && (
            <>
              <ListItem
                button
                onClick={handleAnalyticsClick}
                selected={isAnalyticsSelected}
                classes={{ root: classes.selectedCollapse }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <AnalyticsIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Analytics"
                  className={clsx({
                    [classes.selectedText]: isAnalyticsTextHighlighted,
                  })}
                />
                {analyticsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={analyticsOpen}
                timeout="auto"
                unmountOnExit
                className={classes.expandedMenuItem}
              >
                <List component="div" disablePadding>
                  {isCEOUser && (
                    <>
                      {hasCustomerAnalytics && (
                        <LightTooltip
                          title={
                            !isTeamAnalyticsAllowed ? tooltipTextForNonDSA : ""
                          }
                        >
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLinkForNoTenant(
                                customerAnalyticsLink,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(
                              pathName,
                              customerAnalyticsLink
                            )}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <CustomersIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Customers"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  customerAnalyticsLink
                                ),
                              })}
                            />
                            {!isTeamAnalyticsAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {hasTeamAnalytics && (
                        <LightTooltip
                          title={
                            !isTeamAnalyticsAllowed ? tooltipTextForNonDSA : ""
                          }
                        >
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLinkForNoTenant(
                                teamAnalyticsLink,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(pathName, teamAnalyticsLink)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <TeamsIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Team"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  teamAnalyticsLink
                                ),
                              })}
                            />
                            {!isTeamAnalyticsAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {hasCarrierAnalytics && (
                        <LightTooltip
                          title={
                            !isCarrierAnalyticsAllowed
                              ? tooltipTextForNonDSA
                              : ""
                          }
                        >
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLinkForNoTenant(
                                carrierAnalyticsLink,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(pathName, carrierAnalyticsLink)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <CarriersIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Carriers"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  carrierAnalyticsLink
                                ),
                              })}
                            />
                            {!isCarrierAnalyticsAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isForecastAllowed && (
                        <LightTooltip
                          title={
                            !isForesightAllowed ? tooltipTextForNonDSA : ""
                          }
                        >
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLinkForNoTenant(
                                FORESIGHT_PATH,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(pathName, FORESIGHT_PATH)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <ForesightIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Foresight"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  FORESIGHT_PATH
                                ),
                              })}
                            />
                            {!isForesightAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isBenchmarkAllowed && (
                        <LightTooltip
                          title={
                            !isBenchmarkAllowedForPlan
                              ? tooltipTextForNonDSA
                              : ""
                          }
                        >
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLinkForNoTenant(
                                BENCHMARK_PATH,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(pathName, BENCHMARK_PATH)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <BenchmarkingIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Benchmarking"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  BENCHMARK_PATH
                                ),
                              })}
                            />
                            {!isBenchMarkAllowedForPlan && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isEnrichmentDashboardAllowed && (
                        <LightTooltip
                          title={
                            !isdataEnrichmentAllowed ? tooltipTextForNonDSA : ""
                          }
                        >
                          <ListItem
                            button
                            onClick={() =>
                              handleLinkForNoTenant(
                                ENRICHMENT_PATH,
                                isWidgetAllowedForNoTenant
                              )
                            }
                            selected={matchPath(pathName, ENRICHMENT_PATH)}
                            className={classes.nested}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <DataEnrichmentIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Data Enrichment"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  ENRICHMENT_PATH
                                ),
                              })}
                            />
                            {!isdataEnrichmentAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                    </>
                  )}
                  {hasTrendsAnalytics && (
                    <LightTooltip
                      title={!isTrendsAllowed ? tooltipTextForNonDSA : ""}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() =>
                          handleLinkForNoTenant(
                            trendsAnalyticsLink,
                            isWidgetAllowedForNoTenant
                          )
                        }
                        selected={matchPath(pathName, trendsAnalyticsLink)}
                        classes={{ root: classes.selected }}
                      >
                        <ListItemIcon classes={{ root: classes.icon }}>
                          <TrendsIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Trends"
                          className={clsx({
                            [classes.selectedText]: matchPath(
                              pathName,
                              trendsAnalyticsLink
                            ),
                          })}
                        />
                        {!isTrendsAllowed && <LockMenu hideTooltip={true} />}
                      </ListItem>
                    </LightTooltip>
                  )}
                </List>
              </Collapse>
            </>
          )}
          {isCEOUser && hasSettings && (
            <LightTooltip
              title={!isWidgetAllowedForNoTenant ? tooltipTextForNonDSA : ""}
            >
              <ListItem
                button
                onClick={() =>
                  handleLinkForNoTenant(
                    SETTING_PATH,
                    isWidgetAllowedForNoTenant
                  )
                }
                selected={matchPath(pathName, SETTING_PATH)}
                classes={{ root: classes.selected }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Settings"
                  className={clsx({
                    [classes.selectedText]: matchPath(pathName, SETTING_PATH),
                  })}
                />
                {!isWidgetAllowedForNoTenant && <LockMenu hideTooltip={true} />}
              </ListItem>
            </LightTooltip>
          )}
        </>
      )}
      {!doesNotHaveTenant && (
        <>
          <div>
            <ListItem
              button
              onClick={handleDashboardClick}
              selected={isDashboardSelected}
              classes={{ root: classes.selectedCollapse }}
            >
              <ListItemIcon classes={{ root: classes.icon }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary="Dashboards"
                className={clsx({
                  [classes.selectedText]: isDashboardTextHighlighted,
                })}
              />
              {!dashboardOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={!dashboardOpen}
              timeout="auto"
              unmountOnExit
              className={classes.expandedMenuItem}
            >
              <List component="div" disablePadding>
                {isCEOUser && (
                  <>
                    {hasOverallDashboard && (
                      <ListItem
                        button
                        onClick={() => handleLink(OVERALL_DASHBOARD_PATH)}
                        selected={matchPath(pathName, OVERALL_DASHBOARD_PATH)}
                        classes={{ root: classes.selected }}
                        className={classes.nested}
                      >
                        <ListItemIcon classes={{ root: classes.icon }}>
                          <AnalyticsIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Analytics"
                          className={clsx({
                            [classes.selectedText]: matchPath(
                              pathName,
                              OVERALL_DASHBOARD_PATH
                            ),
                          })}
                        />
                      </ListItem>
                    )}
                    {(isCEOUser && !isPowerUser) && (
                      <ListItem
                        button
                        onClick={() => handleLink(SIAA_DOMO_DASHBOARD_PATH)}
                        selected={matchPath(pathName, SIAA_DOMO_DASHBOARD_PATH)}
                        className={classes.nested}
                        classes={{ root: classes.selected }}
                      >
                        <ListItemIcon classes={{ root: classes.icon }}>
                          <BarChartIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={DOMO_TITLE}
                          className={clsx({
                            [classes.selectedText]: matchPath(
                              pathName,
                              SIAA_DOMO_DASHBOARD_PATH
                            ),
                          })}
                        />
                      </ListItem>
                    )}
                  </>
                )}
                {(!isCEOUser || isSuperUser || isPowerUser) && hasMetricsAnalytics && (
                  <ListItem
                    button
                    className={classes.nested}
                    onClick={() =>
                      handleLink(
                        metricsAnalyticsLink
                        // isMetricsAllowed,
                        // "Metrics"
                      )
                    }
                    selected={matchPath(pathName, metricsAnalyticsLink)}
                    classes={{ root: classes.selected }}
                  >
                    <ListItemIcon classes={{ root: classes.icon }}>
                      <MetricsIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Metrics"
                      className={clsx({
                        [classes.selectedText]: matchPath(
                          pathName,
                          metricsAnalyticsLink
                        ),
                      })}
                    />
                    {!isMetricsAllowed && <LockMenu hideTooltip={true} />}
                  </ListItem>
                )}
                {isCEOUser && (
                  <ListItem
                    button
                    onClick={() => handleLink(SPC_DASHBOARD_PATH)}
                    selected={matchPath(pathName, SPC_DASHBOARD_PATH)}
                    className={classes.nested}
                    classes={{ root: classes.selected }}
                  >
                    <ListItemIcon classes={{ root: classes.icon }}>
                      <EmojiEventsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={SPC_DASHBOARD_TITLE}
                      className={clsx({
                        [classes.selectedText]: matchPath(
                          pathName,
                          SPC_DASHBOARD_PATH
                        ),
                      })}
                    />
                  </ListItem>
                )}
              </List>
            </Collapse>
          </div>
          {(isCEOUser && !isPowerUser) && (
            <div>
              <ListItem
                button
                onClick={handleAutomationClick}
                selected={false}
                classes={{ root: classes.selectedCollapse }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <SwapVertIcon />
                </ListItemIcon>
                <ListItemText primary="Automation" className={clsx({})} />
                {automationOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={automationOpen}
                timeout="auto"
                unmountOnExit
                className={classes.expandedMenuItem}
              >
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() =>
                      handleRedirect(SIAA_REMITTANCE_REDIRECTTO_PATH)
                    }
                    // selected={matchPath(pathName, SIAA_DOMO_DASHBOARD_PATH)}
                    className={classes.nested}
                    classes={{ root: classes.selected }}
                  >
                    <ListItemIcon classes={{ root: classes.icon }}>
                      <AttachMoneyIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={REMITTANCE_TITLE}
                      className={clsx({
                        [classes.selectedText]: matchPath(
                          pathName,
                          SIAA_REMITTANCE_REDIRECTTO_PATH
                        ),
                      })}
                    />
                    <LaunchIcon />
                  </ListItem>
                </List>
              </Collapse>
            </div>
          )}

          <div>
            <ListItem
              button
              onClick={handleViewsClick}
              selected={isViewsSelected}
              classes={{ root: classes.selectedCollapse }}
            >
              <ListItemIcon classes={{ root: classes.icon }}>
                <MyViewsIcon />
              </ListItemIcon>
              <ListItemText primary="My Views" className={clsx({})} />
              {viewsOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={viewsOpen}
              timeout="auto"
              unmountOnExit
              className={classes.expandedMenuItem}
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => handleLink(`${viewPath}/default`)}
                  selected={matchPath(pathName, `${viewPath}/default`)}
                  classes={{ root: classes.selected }}
                >
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <DefaultViewIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Default View"
                    className={clsx({
                      [classes.selectedText]: matchPath(
                        pathName,
                        `${viewPath}/default`
                      ),
                    })}
                  />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => handleLink(`${viewPath}/viewAll/myList`)}
                  selected={matchPath(pathName, `${viewPath}/viewAll/myList`)}
                  classes={{ root: classes.selected }}
                >
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="My List"
                    className={clsx({
                      [classes.selectedText]: matchPath(
                        pathName,
                        `${viewPath}/viewAll/myList`
                      ),
                    })}
                  />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => handleLink(`${viewPath}/viewAll/RoundOut`)}
                  selected={matchPath(pathName, `${viewPath}/viewAll/RoundOut`)}
                  classes={{ root: classes.selected }}
                >
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <RoundoutIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Round Out"
                    className={clsx({
                      [classes.selectedText]: matchPath(
                        pathName,
                        `${viewPath}/viewAll/RoundOut`
                      ),
                    })}
                  />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => handleLink(`${viewPath}/viewAll/Retain`)}
                  selected={matchPath(pathName, `${viewPath}/viewAll/Retain`)}
                  classes={{ root: classes.selected }}
                >
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <RetainIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Retain"
                    className={clsx({
                      [classes.selectedText]: matchPath(
                        pathName,
                        `${viewPath}/viewAll/Retain`
                      ),
                    })}
                  />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => handleLink(`${viewPath}/viewAll/Renew`)}
                  selected={matchPath(pathName, `${viewPath}/viewAll/Renew`)}
                  classes={{ root: classes.selected }}
                >
                  <ListItemIcon classes={{ root: classes.icon }}>
                    <RenewIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Renew"
                    className={clsx({
                      [classes.selectedText]: matchPath(
                        pathName,
                        `${viewPath}/viewAll/Renew`
                      ),
                    })}
                  />
                </ListItem>
              </List>
            </Collapse>
          </div>
          {enableAnalytics && (
            <>
              <ListItem
                button
                onClick={handleAnalyticsClick}
                selected={isAnalyticsSelected}
                classes={{ root: classes.selectedCollapse }}
              >
                <ListItemIcon classes={{ root: classes.icon }}>
                  <AnalyticsIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Analytics"
                  className={clsx({
                    [classes.selectedText]: isAnalyticsTextHighlighted,
                  })}
                />
                {analyticsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={analyticsOpen}
                timeout="auto"
                unmountOnExit
                className={classes.expandedMenuItem}
              >
                <List component="div" disablePadding>
                  {isCEOUser && (
                    <>
                      {hasCustomerAnalytics && (
                        <ListItem
                          button
                          className={classes.nested}
                          onClick={() => handleLink(customerAnalyticsLink)}
                          selected={matchPath(pathName, customerAnalyticsLink)}
                          classes={{ root: classes.selected }}
                        >
                          <ListItemIcon classes={{ root: classes.icon }}>
                            <CustomersIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="Customers"
                            className={clsx({
                              [classes.selectedText]: matchPath(
                                pathName,
                                customerAnalyticsLink
                              ),
                            })}
                          />
                        </ListItem>
                      )}
                    </>
                  )}
                  {isCEOUser && (
                    <>
                      {hasTeamAnalytics && (
                        <LightTooltip title={!isTeamAnalyticsAllowed ? tooltipTextForDSA : ""}>
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLink(
                                teamAnalyticsLink,
                                isTeamAnalyticsAllowed,
                                "Team Analytics"
                              )
                            }
                            selected={matchPath(pathName, teamAnalyticsLink)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <TeamsIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Team"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  teamAnalyticsLink
                                ),
                              })}
                            />
                            {!isTeamAnalyticsAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {hasCarrierAnalytics && (
                        <LightTooltip title={!isCarrierAnalyticsAllowed ? tooltipTextForDSA : ""}>
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLink(
                                carrierAnalyticsLink,
                                isCarrierAnalyticsAllowed,
                                "Carrier Analytics"
                              )
                            }
                            selected={matchPath(pathName, carrierAnalyticsLink)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <CarriersIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Carriers"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  carrierAnalyticsLink
                                ),
                              })}
                            />
                            {!isCarrierAnalyticsAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isForecastAllowed && (
                        <LightTooltip title={!isForesightAllowed ? tooltipTextForDSA : ""}>
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLink(
                                FORESIGHT_PATH,
                                isForesightAllowed,
                                "Foresight"
                              )
                            }
                            selected={matchPath(pathName, FORESIGHT_PATH)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <ForesightIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Foresight"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  FORESIGHT_PATH
                                ),
                              })}
                            />
                            {!isForesightAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isBenchmarkAllowed && (
                        <LightTooltip title={!isBenchMarkAllowedForPlan ? tooltipTextForDSA : ""}>
                          <ListItem
                            button
                            className={classes.nested}
                            onClick={() =>
                              handleLink(
                                BENCHMARK_PATH,
                                isBenchMarkAllowedForPlan,
                                "Benchmark"
                              )
                            }
                            selected={matchPath(pathName, BENCHMARK_PATH)}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <BenchmarkingIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Benchmarking"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  BENCHMARK_PATH
                                ),
                              })}
                            />
                            {!isBenchMarkAllowedForPlan && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                      {isEnrichmentDashboardAllowed && (
                        <LightTooltip title={!isdataEnrichmentAllowed ? tooltipTextForDSA : ""}>
                          <ListItem
                            button
                            onClick={() =>
                              handleLink(
                                ENRICHMENT_PATH,
                                isdataEnrichmentAllowed,
                                "Enrichment Dashboard"
                              )
                            }
                            selected={matchPath(pathName, ENRICHMENT_PATH)}
                            className={classes.nested}
                            classes={{ root: classes.selected }}
                          >
                            <ListItemIcon classes={{ root: classes.icon }}>
                              <DataEnrichmentIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary="Data Enrichment"
                              className={clsx({
                                [classes.selectedText]: matchPath(
                                  pathName,
                                  ENRICHMENT_PATH
                                ),
                              })}
                            />
                            {!isdataEnrichmentAllowed && (
                              <LockMenu hideTooltip={true} />
                            )}
                          </ListItem>
                        </LightTooltip>
                      )}
                    </>
                  )}
                  {(!isCEOUser || isSuperUser) && hasPortfolio && (
                    <ListItem
                      button
                      onClick={() => handleLink(PORTFOLIO_PATH)}
                      selected={matchPath(pathName, PORTFOLIO_PATH)}
                      className={classes.nested}
                      classes={{ root: classes.selected }}
                    >
                      <ListItemIcon classes={{ root: classes.icon }}>
                        <PortfolioIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="My Portfolio"
                        className={clsx({
                          [classes.selectedText]: matchPath(
                            pathName,
                            PORTFOLIO_PATH
                          ),
                        })}
                      />
                    </ListItem>
                  )}
                  {hasTrendsAnalytics && (
                    <LightTooltip title={!isTrendsAllowed ? tooltipTextForDSA : ""}>
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() =>
                          handleLink(
                            trendsAnalyticsLink,
                            isTrendsAllowed,
                            "Trends"
                          )
                        }
                        selected={matchPath(pathName, trendsAnalyticsLink)}
                        classes={{ root: classes.selected }}
                      >
                        <ListItemIcon classes={{ root: classes.icon }}>
                          <TrendsIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Trends"
                          className={clsx({
                            [classes.selectedText]: matchPath(
                              pathName,
                              trendsAnalyticsLink
                            ),
                          })}
                        />
                        {!isTrendsAllowed && <LockMenu hideTooltip={true} />}
                      </ListItem>
                    </LightTooltip>

                  )}
                </List>
              </Collapse>
            </>
          )}
          {isCEOUser && hasSettings && (
            <ListItem
              button
              onClick={() => handleLink(SETTING_PATH)}
              selected={matchPath(pathName, SETTING_PATH)}
              classes={{ root: classes.selected }}
            >
              <ListItemIcon classes={{ root: classes.icon }}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Settings"
                className={clsx({
                  [classes.selectedText]: matchPath(pathName, SETTING_PATH),
                })}
              />
            </ListItem>
          )}
        </>
      )}
      <JiraDrawerItemWithDialog />
    </List>
  );
}

SIAANestedList.propTypes = {
  onClose: PropTypes.func.isRequired,
};
